import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Package = function Package(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [/*#__PURE__*/_jsx("path", {
      d: "m8.593.967 5.333 2.667a1.333 1.333 0 0 1 .74 1.193v6.354a1.334 1.334 0 0 1-.74 1.193l-5.333 2.667a1.335 1.335 0 0 1-1.193 0l-5.334-2.667a1.333 1.333 0 0 1-.733-1.2V4.827a1.333 1.333 0 0 1 .74-1.193L7.406.967a1.333 1.333 0 0 1 1.187 0v0Z",
      stroke: color,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M1.547 4.107 8 7.334l6.454-3.227M8 15.174v-7.84M4.667 2.334l6.667 3.333",
      stroke: color,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};
export default Package;